import {
    IntentKind,
    makeIntentBuilderFunction,
    makeIntentGuard,
    type RouteableIntent,
} from '@jet-app/music-classical/intents';

export enum LibraryListPageType {
    Album = 'albums',
    Artist = 'artists',
    Composer = 'composers',
    Recording = 'recordings',
    Track = 'tracks',
    Work = 'works',
}

/**
 * List of `pageType`s that can be handled by LibraryListPageIntent
 */
export const LIBRARY_LIST_PAGE_TYPE_ALLOWLIST = [
    LibraryListPageType.Album,
    LibraryListPageType.Artist,
    LibraryListPageType.Composer,
    LibraryListPageType.Recording,
    LibraryListPageType.Work,
];

export interface LibraryListPageIntent extends RouteableIntent {
    $kind: IntentKind.LIBRARY_LIST_PAGE;
    pageType: LibraryListPageType;
    metadata?: any;
}

export const isLibraryListPageIntent = makeIntentGuard<LibraryListPageIntent>(
    IntentKind.LIBRARY_LIST_PAGE,
);

export const makeLibraryListPageIntent =
    makeIntentBuilderFunction<LibraryListPageIntent>(
        IntentKind.LIBRARY_LIST_PAGE,
    );
